import React from "react";
import "../style/BaseInfo.css";

const CarneInfo = (props) => {
  const checkList = props.ingredienti;

  const handleCheck = async (event) => {
    let ing = props.ingredienti.find(
      (p) => p.id_ingredienti == event.target.value
    );
    var updatedList = [...props.formData.carne];
    if (event.target.checked) {
      updatedList = [
        ...props.formData.carne,
        props.ingredienti.find((p) => p.id_ingredienti == event.target.value),
      ];
      props.setFormData({
        ...props.formData,
        carne: updatedList,
        totale: Number(props.formData.totale) + Number(ing.prezzo),
      });
    } else {
      updatedList.splice(
        props.formData.carne.findIndex(
          (p) => p.id_ingredienti == event.target.value
        ),
        1
      );
      props.setFormData({
        ...props.formData,
        carne: updatedList,
        totale: Number(props.formData.totale) - Number(ing.prezzo),

      });
    }
  };

  return (
    <div className="container-fornoinfo">
      {checkList.map((item, index) => {
        if (item.categorie_ingredienti.nome == "Carne") {
          return (
            <label className="ingr" key={index}>
              <input
                value={item.id_ingredienti}
                type="checkbox"
                onChange={handleCheck}
                checked={
                  !props.formData.carne.find(
                    (p) => p.id_ingredienti == item.id_ingredienti
                  )
                    ? false
                    : true
                }
              />
              {item.nome} ({item.prezzo} €)
            </label>
          );
        }
      })}
    </div>
  );
};
export default CarneInfo;
